var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('v-container',{staticClass:"px-sm-10",attrs:{"fill-height":""}},[_c('v-layout',{staticClass:"text-center",attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('Home'),_c('AboutUs'),_c('ContactUs')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }